import { createVuetify } from 'vuetify';
import { VDatePicker } from 'vuetify/components';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import { resolveUiLocale } from '../shared/resolveUiLocale';

export function resolveVuetifyLocale(langOrCode) {
    return resolveUiLocale(langOrCode);
}

const BRAND_PRIMARY = '#c8392b';
const BRAND_PRIMARY_DARKEN = '#9a2a1f';

const initialVuetifyLocale = resolveVuetifyLocale(
    typeof window !== 'undefined' ? window.__APP_DATA__?.lang : 'en'
);

const vuetify = createVuetify({
    components: {
        VDatePicker,
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
    locale: {
        locale: initialVuetifyLocale,
        fallback: 'en',
    },
    theme: {
        themes: {
            light: {
                colors: {
                    primary: BRAND_PRIMARY,
                    'primary-darken-1': BRAND_PRIMARY_DARKEN,
                },
            },
            dark: {
                colors: {
                    primary: BRAND_PRIMARY,
                    'primary-darken-1': BRAND_PRIMARY_DARKEN,
                },
            },
        },
    },
});

export default vuetify;
